import Axios from 'axios'
import React, { Component } from 'react'
import config from '../../../Shared/config'
import FieldTypes from './FieldTypes'

export default class Dropdown extends Component {

    constructor(props) {
        super(props)

        this.state = {
            fieldModel: this.props.model,
            fieldEvents: this.props.events,
            value: this.props.value,
            options: [{ id: '', label: '' }]
        }
    }

    componentDidMount() {
        let { model } = this.props
        if (model.getDataFromServer) {
            this.getDropdownOptions(model.schema, model.column, model.separator).then(res => {
                if (res) {
                    this.setState({
                        options: this.state.options.concat(res)
                    })
                } else {
                    this.setState({
                        options: []
                    })
                }
            }).catch(err => {
                console.error(err)
            })
        } else {
            this.setState({
                options: this?.props?.model?.options ? this.state.options.concat(this?.props?.model?.options) : []
            })
        }
    }

    getDropdownOptions = async (schema, column, separator) => {
        const url = `${config.apiUrl}/common/getDropdownOptions?schema=${schema}&column=${column}&separator=${separator}`
        return Axios.get(url).then(res => {
            if (!res?.data?.error) {
                return res.data.data
            } else {
                return null
            }
        })
    }

    render() {

        const { fieldModel, fieldEvents, options } = this.state

        return (
            <select
                className='value'
                id={fieldModel.id}
                name={fieldModel.name}
                onChange={fieldEvents.onChange}
                fieldtype={FieldTypes.dropdown}
            >
                {
                    options.map((item, idx) => (
                        <option value={item.id}>{item.label}</option>
                    ))
                }
                {/* <option value="volvo">Volvo</option>
                <option value="saab">Saab</option>
                <option value="mercedes">Mercedes</option>
                <option value="audi">Audi</option> */}
            </select>
        )
    }
}
